import React, { useContext, useEffect, useMemo, useState } from 'react';
import Lottie from 'react-lottie';

import { Animations } from '~/assets';
import { ImportantBox, Steps } from '~/components';
import history from '~/config/history';
import { Context as QueryContext } from '~/contexts/QueryContext';
import { PATHS } from '~/routes/paths';
import api, { Endpoints } from '~/services/api';

import { Container, Content, Texto } from './styles';

const Finalizado = ({ typeFinishing }) => {
  const { params } = useContext(QueryContext);
  const [steps, setSteps] = useState([]);
  const data = useMemo(() => history?.location?.state, []);

  useEffect(() => {
    if (!data) {
      history.replace(PATHS.loading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getStatus = async () => {
      try {
        const { data: status } = await api.get(Endpoints.BUSCAR_STATUS + params.idAssistServico);

        setSteps(
          status.map(({ status: { descricao }, dataTerminoStatus: dataStatus = null }) => ({
            name: descricao,
            isCompleted: !!dataStatus,
            date: dataStatus ? new Date(dataStatus) : undefined,
          }))
        );
      } catch (error) {
        console.error(error);
      }
    };

    if (params?.idAssistServico) getStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderMessage = () => {
    if (typeFinishing === 0) {
      return (
        <Texto>
          {data?.nomeCliente}, a consulta foi agendada com sucesso.
          <br />
          Qualquer dúvida entre em contato com nossa central
          <br />
          {data?.clienteCorporativoTelefone}
          <br />
          <br />
          Em breve retornaremos para confirmar a realização da consulta.
        </Texto>
      );
    }
    if (typeFinishing === 1) {
      return (
        <Texto>
          Recebemos a sua resposta, obrigado pela sua confirmação. Em breve lhe encaminharemos uma
          pesquisa de satisfação!
        </Texto>
      );
    }

    return null;
  };

  return (
    <Container>
      <Steps steps={steps} />

      <Content>
        <div>
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: Animations.Check,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
              },
            }}
            height={window.screen.width >= 768 ? 158 : 100}
            width={window.screen.width >= 768 ? 158 : 100}
            isClickToPauseDisabled
          />
          ;
        </div>

        {renderMessage()}
      </Content>

      {typeFinishing === 0 && (
        <ImportantBox>
          Durante realização da consulta, poderá haver procedimentos adicionais ao limite da sua
          cobertura, que serão cobrados mediante sua aprovação.
        </ImportantBox>
      )}
    </Container>
  );
};

export default Finalizado;
